import { IFlowDesignerSettingsStore, FlowDesignerSettingsActions } from "../types/stores/flowDesigner";
import type { Flow } from "../types/flowTypes";

// States for flow designer tools
export const TOGGLE_FLOW_LISTING = "TOGGLE_FLOW_LISTING";
export const TOGGLE_FLOW_LISTING_PINNABLE = "TOGGLE_FLOW_LISTING_PINNABLE";
export const SET_FLOW_PROCESS_TYPE = "SET_FLOW_PROCESS_TYPE";
export const SET_FLOW_CLOSED = "SET_FLOW_CLOSED";
export const SET_PREVIOUS_FLOW_FOLDER = "SET_PREVIOUS_FLOW_FOLDER";
/** Ephemeral name-search hits for the flow design tree only; does not replace `flows.byId`. */
export const SET_FLOW_NAME_SEARCH_OVERLAY = "SET_FLOW_NAME_SEARCH_OVERLAY";
export const CLEAR_FLOW_NAME_SEARCH_OVERLAY = "CLEAR_FLOW_NAME_SEARCH_OVERLAY";

const initialState: IFlowDesignerSettingsStore = {
    isFlowListingOpen: false,
    isFlowListingPinned: true,
    processType: 1, // default 'execute'
    hasPreviouslyClosed: false,
    previousFolderId: null,
    flowNameSearchQuery: "",
    flowNameSearchOverlayById: {} as { [flowId: number]: Flow },
};

function flowDesignerSettings(state = initialState, action: FlowDesignerSettingsActions): IFlowDesignerSettingsStore {
    switch (action.type) {
        case TOGGLE_FLOW_LISTING:
            return Object.assign({}, state, {
                isFlowListingOpen: action.isOpen,
            });
        case TOGGLE_FLOW_LISTING_PINNABLE:
            return Object.assign({}, state, {
                isFlowListingPinned: action.isPinned,
            });
        case SET_FLOW_PROCESS_TYPE: {
            return Object.assign({}, state, {
                processType: action.processType,
            });
        }
        case SET_FLOW_CLOSED: {
            return Object.assign({}, state, {
                hasPreviouslyClosed: action.hasClosed,
            });
        }
        case SET_PREVIOUS_FLOW_FOLDER: {
            return Object.assign({}, state, {
                previousFolderId: action.folderId,
            });
        }
        case SET_FLOW_NAME_SEARCH_OVERLAY: {
            return Object.assign({}, state, {
                flowNameSearchQuery: action.query,
                flowNameSearchOverlayById: action.flowsById || {},
            });
        }
        case CLEAR_FLOW_NAME_SEARCH_OVERLAY: {
            return Object.assign({}, state, {
                flowNameSearchQuery: "",
                flowNameSearchOverlayById: {},
            });
        }
        default:
            return state;
    }
}
export default flowDesignerSettings;
